/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { TwoFactorConfirmRequest } from '../../models/two-factor-confirm-request';
import { TwoFactorConfirmResult } from '../../models/two-factor-confirm-result';

export interface Confirm$Params {
      body: TwoFactorConfirmRequest
}

export function confirm(http: HttpClient, rootUrl: string, params: Confirm$Params, context?: HttpContext): Observable<StrictHttpResponse<TwoFactorConfirmResult>> {
  const rb = new RequestBuilder(rootUrl, confirm.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<TwoFactorConfirmResult>;
    })
  );
}

confirm.PATH = '/auth/2fa/confirm';
